// Common colors for the application
// These can be easily changed for light/dark mode switching

export const colors = {
  // Primary colors
  primary: '#ff4e3a',
  primaryDark: '#e6402f',
  secondary: '#3e3c56',
  
  // Background colors
  darkBackground: '#1a1a2e',
  mediumBackground: '#3e3c56',
  lightBackground: '#484860',
  
  // Text colors
  lightText: '#ffffff',
  mediumText: 'rgba(255, 255, 255, 0.7)',
  
  // Border colors
  border: 'rgba(255, 255, 255, 0.12)',
  
  // Status colors
  success: '#4CAF50',
  warning: '#FFC107',
  error: '#F44336'
};

// For future light mode
export const lightModeColors = {
  primary: '#ff4e3a',
  primaryDark: '#e6402f',
  secondary: '#f0f0f5',
  darkBackground: '#ffffff',
  mediumBackground: '#f5f5f5',
  lightBackground: '#e8e8e8',
  lightText: '#333333',
  mediumText: '#666666',
  border: 'rgba(0, 0, 0, 0.12)',
  success: '#4CAF50',
  warning: '#FFC107',
  error: '#F44336'
}; 